export default __webpack_public_path__ + "static/media/ar.10ea98e2.svg";